import { render, staticRenderFns } from "./managementAwardRule.vue?vue&type=template&id=2edf7253&scoped=true&"
import script from "./managementAwardRule.vue?vue&type=script&lang=js&"
export * from "./managementAwardRule.vue?vue&type=script&lang=js&"
import style0 from "./managementAwardRule.vue?vue&type=style&index=0&id=2edf7253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf7253",
  null
  
)

export default component.exports